import {SlideType} from '../../../../../../graphql/generated/types';
import {ViewerType} from '../constant/viewerConstant';

export function slideTypeToViewerType(slideType: SlideType): ViewerType {
  switch (slideType) {
    case SlideType.Epub:
      return ViewerType.TextViewer;
    case SlideType.TalkNovel:
      return ViewerType.TalkViewer;
    case SlideType.Comic:
      return ViewerType.ImageViewer;
    case SlideType.TalkHumor:
      return ViewerType.VideoViewer;
    default:
      return ViewerType.None;
  }
}
